<template>
  <div id="app" class="site container hfeed" style="height: auto !important">
    <HeadNav selectedLanguage="en" page="download" />
    <SiteBreadcrumb />

    <div class="main-wrapper" style="height: auto !important;">
      <hh1>Download GB WhatsApp APK Latest Version 2026</hh1>
      <article>
        <p>
<strong>GB WhatsApp</strong> APK Download 2026 safely from our website — your trusted source for updated,
          virus-free files. Enjoy anti-ban, privacy tools, themes & more on Android.
</p>

        <DownloadBtn value="Download GB WhatsApp APK" style="width: fit-content;" mg="1" @click-btn="download" />
        <hh2><strong>Quick Details</strong></hh2>
        <ul>
          <li><strong>App Name</strong>: <a href="/">GB WhatsApp</a></li>
          <li><strong>Version</strong>: v18.80</li>
          <li><strong>Size</strong>: 65 MB</li>
          <li><strong>Available For</strong>: Android 5.0 and up</li>
        </ul>

        <hh2>How to install it？</hh2>
        <p>
Click "OK" on Chrome, then click the Download complete notification after download There may be warnings
          while you downloading an apk file on Chrome. Click OK to Continue.
</p>

        <p>GB WhatsApp is Safe, Thanks for your trust</p>
      </article>
</div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';
import DownloadBtn from '@/components/DownloadBtn.vue';

export default {
  name: 'Download',
  components: {
    HeadNav, DownloadBtn
  },
  data() {
    return {
      pageName: 'download',
      showapk: false,

      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      // this.download();
      // this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    download() {
      // 普通下载页优先使用环境变量中的官方 APK 直链；带 from 参数时仍走推广接口返回的地址
      let apkUrl = this.apk;
      if (!this.$global.GetQueryString('from')) {
        apkUrl =
          process.env.VUE_APP_GBLINK ||
          process.env.VUE_APP_DEFAULT_APK ||
          apkUrl;
      }
      console.log('========apk======', apkUrl);
      if (apkUrl) {
        this.$global.download(apkUrl);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
    // download() {
    // 	console.log(this.apk);
    // 	this.$global.download(this.apk);
    // },
  },
};
</script>

<style lang="scss" scoped>
.main-wrapper article a {
  color: #128c7e;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    color: #25d366;
  }
}
</style>